export const SYMBOL_X = "☓";
export const SYMBOL_CHECK_MARK = "✓";
